import { render, staticRenderFns } from "./ModeloEstrangeiro.vue?vue&type=template&id=a79eaf52&scoped=true"
import script from "./ModeloEstrangeiro.vue?vue&type=script&lang=js"
export * from "./ModeloEstrangeiro.vue?vue&type=script&lang=js"
import style0 from "./ModeloEstrangeiro.vue?vue&type=style&index=0&id=a79eaf52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79eaf52",
  null
  
)

export default component.exports